(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["objecttalks-landing"] && !Shopify.designMode) return;
  try {
    

(function(){
function init(){
 const root=document.documentElement,mode=document.querySelector('[data-mode]');
 if(mode)mode.onclick=function(){let dark=root.dataset.theme==='dark'||(!root.dataset.theme&&matchMedia('(prefers-color-scheme: dark)').matches);root.dataset.theme=dark?'light':'dark';mode.setAttribute('aria-pressed',String(!dark));try{localStorage.setItem('objecttalks-theme',root.dataset.theme)}catch(e){}};
 if(mode)mode.setAttribute('aria-pressed',String(root.dataset.theme==='dark'||(!root.dataset.theme&&matchMedia('(prefers-color-scheme: dark)').matches)));
 const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 if('IntersectionObserver'in window){
  if(!reduced){root.classList.add('motion');const reveal=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');reveal.unobserve(e.target)}})},{threshold:.08});document.querySelectorAll('.reveal').forEach(e=>reveal.observe(e));}
  const sticky=document.querySelector('.sticky'),hero=document.querySelector('.hero'),offer=document.getElementById('get-bundle');let heroGone=false,offerSeen=false;
  const observe=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.target===hero)heroGone=!e.isIntersecting&&e.boundingClientRect.bottom<0;if(e.target===offer)offerSeen=e.isIntersecting});if(sticky)sticky.classList.toggle('visible',heroGone&&!offerSeen)});if(hero)observe.observe(hero);if(offer)observe.observe(offer);
 }
 const forms=document.querySelectorAll('[data-buy-form]'),selector=document.querySelector('[data-variant-select]');
 function variantChanged(){if(!selector)return;const option=selector.selectedOptions[0];forms.forEach(f=>{f.querySelector('[name="id"]').value=option.value;f.querySelector('button').disabled=option.dataset.available!=='true';f.querySelector('button [data-buy-label]').textContent=option.dataset.available==='true'?f.dataset.buyLabel:f.dataset.soldLabel});document.querySelectorAll('[data-price]').forEach(el=>el.textContent=option.dataset.price)}
 if(selector){selector.addEventListener('change',variantChanged);variantChanged()}
 forms.forEach(function(form){form.addEventListener('submit',async function(e){
  if(!window.fetch)return;e.preventDefault();const btn=form.querySelector('button'),error=form.querySelector('[data-error]');if(btn.disabled)return;btn.disabled=true;btn.setAttribute('aria-busy','true');if(error)error.hidden=true;
  try{const cartRoot=form.dataset.cartRoot||'/';const payload={items:[{id:Number(form.querySelector('[name="id"]').value),quantity:1}]};const res=await fetch(cartRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});const data=await res.json();if(!res.ok)throw new Error(data.description||data.message||form.dataset.errorLabel);window.location.assign(cartRoot+'checkout')}
  catch(err){if(error){error.textContent=err.message||form.dataset.errorLabel;error.hidden=false}btn.disabled=false;btn.removeAttribute('aria-busy')}
 })});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
